import axios from "axios";
import { authFormPost, authPost } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/w188_api";

export function callGroupUI(queryParams) {
  return authPost(`${baseUrl}/Member5.ashx`, queryParams);
}
